import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 发票信息
    invoiceInfo: {}
  },
  mutations: {
    // 记录发票信息
    SET_INVOICE_INFO(state, info) {
      state.invoiceInfo = info
    }
  },
  getters: {
    invoiceInfo: state => state.invoiceInfo
  },
  actions: {
    //
  },
  modules: {
    //
  }
})
